// src/components/Hero.js

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  UserCircleIcon, 
  VideoCameraIcon, 
  DocumentTextIcon 
} from '@heroicons/react/24/outline'; // Updated import path for Heroicons v2

const Hero = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleDemoVideoClick = () => {
    // Assuming the demo video is located at public/videos/demo-video.mp4
    window.open('/videos/Houval%20-%20Instructional%20video.mp4', '_blank');
  };

  const handleBrochureClick = () => {
    // Assuming the brochure is located at public/documents/brochure.pdf
    window.open('/pdfs/brochure.pdf', '_blank');
  };
  
  return (
    <section className="relative w-full h-screen flex items-center justify-center" id="hero">
      {/* Video Background */}
      <video
        className="absolute top-0 left-0 w-full h-full object-cover"
        src="/videos/hero-background.mp4" // Path to your video
        autoPlay
        loop
        muted
        playsInline
        // poster="/images/video-poster.jpg" // Optional: Poster image for fallback
      ></video>

      {/* Overlay for better text readability */}
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-80"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-10">
        <h1 className="text-3xl md:text-5xl text-white mb-8">
          Using modern technology to automate detailed house valuation reports, reducing ambiguity in buying homes
        </h1>
        <div className="flex flex-col md:flex-row items-center justify-center space-y-4 md:space-y-0 md:space-x-6">
          <button
            onClick={handleLoginClick}
            className="flex items-center bg-yellow-500 text-black px-6 py-3 rounded-full text-lg hover:bg-yellow-600 transition duration-300"
          >
            <UserCircleIcon className="h-6 w-6 mr-2" />
            Sign Up / Login
          </button>
          <button
            onClick={handleDemoVideoClick}
            className="flex items-center bg-yellow-500 text-black px-6 py-3 rounded-full text-lg hover:bg-yellow-600 transition duration-300"
          >
            <VideoCameraIcon className="h-6 w-6 mr-2" />
            Demo Video
          </button>
          <button
            onClick={handleBrochureClick}
            className="flex items-center bg-yellow-500 text-black px-6 py-3 rounded-full text-lg hover:bg-yellow-600 transition duration-300"
          >
            <DocumentTextIcon className="h-6 w-6 mr-2" />
            Brochure
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
